import { type ProductData } from "~/domains/product/types/ProductData";
import { LinkType } from "../Link";
import { Trans } from "react-i18next";
import { userIsLoggedIn } from "~/domains/user/utils/roles";
import { hasSuccessor } from "~/utils/productUtils";
import { Alert } from "~/common/mui/Alert/Alert";
import { Product } from "~/domains/product/Product";
import { ProductContext } from "~/domains/product/ProductContext";

interface Props {
  baseProduct: { successorProduct?: Pick<ProductData, "url" | "designation"> };
  className?: string;
  disableLink?: boolean;
  onClick?: () => void;
}

export const NewVersionMessage = ({ baseProduct, disableLink, onClick, ...rest }: Props) => {
  if (!NewVersionMessage.isVisible(baseProduct)) {
    return null;
  }

  const successorProduct = baseProduct.successorProduct as ProductData;

  if (disableLink && !onClick) {
    return (
      <Alert severity={"info"} {...rest}>
        <Trans i18nKey={"product.hasNewerVersion"}>
          newer version is existing <span className={"d-inline"}>{{ name: successorProduct.designation }}</span>
        </Trans>
      </Alert>
    );
  }

  return (
    <ProductContext value={successorProduct}>
      <Alert severity={"info"} {...rest}>
        <Trans i18nKey={"product.hasNewerVersion"}>
          This product has a new version:{" "}
          <Product.PdpLink variant={LinkType.INHERIT} className="f-bold">
            {{ name: successorProduct.designation }}
          </Product.PdpLink>
        </Trans>
      </Alert>
    </ProductContext>
  );
};

NewVersionMessage.isVisible = (baseProduct: {
  successorProduct?: Pick<ProductData, "url" | "designation">;
}): baseProduct is { successorProduct: Pick<ProductData, "url" | "designation"> } => {
  return userIsLoggedIn() && hasSuccessor(baseProduct);
};
